import { QueryBuilderIndex } from '../types';

export const isCatalog = (esIndex?: QueryBuilderIndex): esIndex is QueryBuilderIndex.Catalog =>
  esIndex === QueryBuilderIndex.Catalog;
